"use strict";

import { CDN } from '@autoguru/global-configs';
export const makeLogosList = [{
  imgPath: `${CDN}/images/nz/landing/make-logos/byd.svg`,
  altText: 'BYD',
  width: 70,
  height: 14
}, {
  imgPath: `${CDN}/images/nz/landing/make-logos/hyundai.svg`,
  altText: 'Hyundai',
  width: 51,
  height: 26
}, {
  imgPath: `${CDN}/images/nz/landing/make-logos/isuzu.svg`,
  altText: 'Isuzu',
  width: 71,
  height: 12
}, {
  imgPath: `${CDN}/images/nz/landing/make-logos/kia.svg`,
  altText: 'Kia',
  width: 56,
  height: 14
}, {
  imgPath: `${CDN}/images/nz/landing/make-logos/mazda.svg`,
  altText: 'Mazda',
  width: 43,
  height: 31
}, {
  imgPath: `${CDN}/images/nz/landing/make-logos/mercedes.svg`,
  altText: 'Mercedes',
  width: 40,
  height: 40
}, {
  imgPath: `${CDN}/images/nz/landing/make-logos/mitsubishi.svg`,
  altText: 'Mitsubishi',
  width: 39,
  height: 32
}, {
  imgPath: `${CDN}/images/nz/landing/make-logos/nissan.svg`,
  altText: 'Nissan',
  width: 39,
  height: 32
}, {
  imgPath: `${CDN}/images/nz/landing/make-logos/suzuki.svg`,
  altText: 'Suzuki',
  width: 47,
  height: 43
}, {
  imgPath: `${CDN}/images/nz/landing/make-logos/toyota.svg`,
  altText: 'Toyota',
  width: 48,
  height: 32
}, {
  imgPath: `${CDN}/images/nz/landing/make-logos/volkswagen.svg`,
  altText: 'Volkswagen',
  width: 32,
  height: 32
}, {
  imgPath: `${CDN}/images/nz/landing/make-logos/volvo.svg`,
  altText: 'Volvo',
  width: 42,
  height: 38
}];